import {
  ArrowRightIcon,
  MOBILE_SCREEN_SIZE,
  TABLET_SCREEN_SIZE,
} from "@brandclub/common-ui";
import { styled } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { useDashboardLinkPrefix } from "../../../utils/hooks/useDashboardLinkPrefix";

const Container = styled("div")(({ theme }) => ({
  padding: "25px 0",
  display: "flex",

  width: "100%",
  boxSizing: "border-box",
  flexDirection: "row",
  justifyContent: "space-between",
  backgroundColor: alpha(theme.palette.secondary.main, 0.2),
  borderRadius: 8,
  alignItems: "center",
  paddingLeft: 25,
  paddingRight: 25,
  paddingVertical: 18,
  gap: 26,
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    padding: "18px 0",
    paddingLeft: 25,
    paddingRight: 25,
  },
  [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    padding: "18px 0",
    paddingLeft: 15,
    paddingRight: 15,
  },
  ".content": {
    gap: 8,
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      gap: 4,
    },
    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      gap: 4,
    },
  },
  ".title": {
    fontSize: 20,
    fontWeight: 600,
    color: theme.vars.palette.primary,
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      fontSize: 14,
    },
    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 14,
    },
  },
  ".text": {
    fontSize: 16,
    fontWeight: 500,
    color: theme.vars.palette.primary,
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      fontSize: 12,
    },
    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 12,
    },
  },
  ".icon": {
    width: 70,
    height: 70,
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      width: 50,
      height: 50,
    },
    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      width: 50,
      height: 50,
    },

    borderRadius: 50,
  },
  ".button_icon": {
    width: 26,
    height: 26,
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      width: 18,
      height: 18,
    },
    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      width: 18,
      height: 18,
    },
  },
}));

const RewardBlockLink = ({
  title,
  text,
}: {
  title?: string;
  text?: string;
}) => {
  const prefix = useDashboardLinkPrefix();
  return (
    <Container>
      <img
        alt=""
        src={"https://media.brandclub.com/brandclub/icons/rewardblock.webp"}
        className="icon"
      ></img>
      <div className="content" style={{ flex: 1 }}>
        <div className="title">{title}</div>
        <div className="text">{text}</div>
      </div>
      <Link to={prefix + "/rewards/balance"}>
        <ArrowRightIcon
          fontSize="large"
          className="button_icon"
          color="primary"
        />
      </Link>
    </Container>
  );
};
export default RewardBlockLink;
